import { Component, OnInit, } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { AppSettings } from '../../shared/configuration/appsettings.config'



@Component({
    selector: 'confirmation',
    templateUrl: './confirmation.component.html'


})
export class ConfirmationComponent implements OnInit {

    referenceNumber: string;

    constructor(private router: Router, private title: Title) {

        this.title.setTitle('Tax Certification Process: Confirmation')
        this.referenceNumber = AppSettings.getReferenceNumber();

    }
    ngOnInit() {
        AppSettings.removeTempCertificationId();
        AppSettings.removereferenceNumber();
    }
    FinishProcess() {
        this.router.navigate(['welcome/']);
    }
    onPrint() {
        window.print();
    }
}



